import React from 'react';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import { MenuItem } from '@mui/material';

interface Props {
  setIsSupportModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  handleMenuClose: () => void;
}

const SupportMenuItem = ({ setIsSupportModalOpen, handleMenuClose }: Props) => {
  return (
    <>
      <MenuItem
        onClick={() => {
          setIsSupportModalOpen(true);
          handleMenuClose();
        }}
      >
        <div
          className="menuLink"
          style={{
            textDecoration: 'none',
            color: 'inherit',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <MailOutlineIcon
            sx={{
              marginRight: '5px',
              transform: 'translateY(1px)',
              width: '20px',
              height: '16px',
              color: '#626265',
            }}
          />
          {/* <img
          src=""
          alt="Support"
          style={{
            marginRight: '8px',
            transform: 'translateY(1px)',
            width: '17px',
            height: '14px',
          }}
        /> */}
          <span>Support</span>
        </div>
      </MenuItem>
    </>
  );
};

export default SupportMenuItem;
